/**
 * Add event listener to user account menu button.
 * When clicked, display user account menu.
 * When clicked again, hide user account menu.
 * When user moves mouse outside of user account menu, hide user account menu.
 */
const userAccountMenu = (function () {
    const _settings = {
        userContainer: document.getElementsByClassName("js-user-container"),
        userMenuButton: document.getElementsByClassName("js-user-menu-button"),
        userMenuContainer: document.getElementsByClassName("m-userNav__container"),
    };

    function init() {
        if (_settings.userContainer.length > 0) {
            // Turn off display of user menu by default
            //    _settings.userMenuContainer[0].style.display = "none";
            //  _createAccountButtonListeners();
            //createAccountMenuContainerListeners();
        }
    }

    function _createAccountButtonListeners() {
        _settings.userMenuButton[0].addEventListener("click", function () {
            _toggleAccountMenu();
        });
    }

    function _toggleAccountMenu() {
        if (
            _settings.userMenuContainer[0].style.getPropertyValue("display") === "" ||
            _settings.userMenuContainer[0].style.getPropertyValue("display") === "none"
        ) {
            _settings.userMenuContainer[0].style.cssText = "display: block";
        } else {
            _settings.userMenuContainer[0].style.cssText = "display: none";
        }
    }

    function createAccountMenuContainerListeners() {
        _settings.userContainer[0].addEventListener("mouseleave", function () {
            _settings.userMenuContainer[0].style.cssText = "display: none";
        });
    }
    return {
        init: init,
    };
})();
export { userAccountMenu };
